import LazyImage from "components/elements/LazyImage";
import Typography from "components/elements/Typography";
import UserPublicResponseResource from "common/resources/User/UserPublicResponseResource";
import { useAvatar } from "hooks/useAvatar";
import classNames from "classnames";
import classes from "./classes.module.scss";
import { useEffect, useState } from "react";
import { container } from "tsyringe";
import SubscriptionPlanService from "services/SubsciptionPlanService";

const subscriptionPlanService = container.resolve(SubscriptionPlanService);

type IProps = {
	user: Pick<UserPublicResponseResource, "id">;
	className?: string;
};

export default function UserBadge(props: IProps) {
	const { avatar } = useAvatar(props.user);
	const { hasSubscriptionPlan } = useSubscriptionPlan(props.user);

	return (
		<div className={classNames(classes["root"], props.className)}>
			<LazyImage src={avatar} alt="Avatar" className={classes["avatar"]} />
			{hasSubscriptionPlan && (
				<Typography type="p" size="xsmall" color="white" weight="bold" className={classes["pro-badge"]}>
					PRO
				</Typography>
			)}
		</div>
	);
}

const useSubscriptionPlan = (user: Pick<UserPublicResponseResource, "id">) => {
	const [hasSubscriptionPlan, setHasSubscriptionPlan] = useState(false);

	useEffect(() => {
		subscriptionPlanService.getSubscriptionPlan(user.id).then((subscriptionPlan) => {
			setHasSubscriptionPlan(subscriptionPlan !== null);
		});
	}, [user]);

	return { hasSubscriptionPlan };
};
